import Typo from "typo-js";
import { TYPO_DICTS_PATH } from "./MiscConstants";
import { sentenceCase } from "../../../front/core/util/StringFormatters";
let dictpath = webpackEnv.location === 'lambda' ? `assets/${TYPO_DICTS_PATH}` : `/assets/${TYPO_DICTS_PATH}`;
let dictionary = new Typo("en_US", false, false, {
    dictionaryPath: dictpath,
});
export function isValidEnglishWord(word) {
    if (dictionary === undefined || !dictionary.loaded) {
        console.warn('Tried to access dictionary before it was loaded!');
        return false;
    }
    return dictionary.check(word.toLowerCase()) || dictionary.check(sentenceCase(word));
}
//# sourceMappingURL=Word.js.map